import { InspectionDetailDatumViewModel } from "src/app/models/inspection-detail-view-models.models";
import { InspectionDetailItem } from "src/app/models/inspection.model";
import { LocaleService } from "src/app/services/locale/locale.service";
import { findUnitIndex } from "../findUnitIndex/findUnitIndex";
import { normalizeTuple } from "../normalizeTuple/normalizeTuple";
import { parseArrayFromString } from "../parseArrayFromString/parse-array-from-string";

/**
 * Concatenate decimals and units and return the value
 * @param param0 InspectionDetailItem object
 * @param param1 InspectionDetailDatumViewModel object
 * @param localeService Locale Service
 * @returns A string with the decimal and unit to render. It returns "—" in case we didn't received data
 */
export const addUnitsToContent = (
	{ inspectionDetailSelectedUnit }: InspectionDetailItem,
	{ inspectionDetailContent, inspectionDetailUnitConversionPair }: InspectionDetailDatumViewModel,
	localeService: LocaleService,
	defaultValue = "—",
): string => {
	let tupleIndex = 0;
	/* Select the index irrespective of the order received to display accurate metrics */
	if (Array.isArray(inspectionDetailUnitConversionPair) && (inspectionDetailUnitConversionPair?.length ?? 0) > 0) {
		tupleIndex = findUnitIndex(localeService, inspectionDetailUnitConversionPair);
	} else {
		tupleIndex = findUnitIndex(localeService, Array(inspectionDetailSelectedUnit));
	}

	/** The response is inconsistent, we need to normalize it as a tuple first */
	let normalizedinspectionDetailContent = inspectionDetailContent;
	if (typeof normalizedinspectionDetailContent === "string") {
		normalizedinspectionDetailContent = parseArrayFromString(normalizedinspectionDetailContent);
	}
	const normalizedValue = (
		Array.isArray(normalizedinspectionDetailContent) // Is inspectionDetailContent an array
			? // normalize tuple
			  normalizeTuple(normalizedinspectionDetailContent)
			: // If it's not an array, turn it into a tuple
			  [inspectionDetailContent, inspectionDetailContent]
	)[tupleIndex];

	/** The response is inconsistent, we need to normalize it as a tuple first */
	const normalizedUnit =
		// if it's not a legacy inspection
		Array.isArray(inspectionDetailUnitConversionPair)
			? // normalize tuple
			  normalizeTuple(inspectionDetailUnitConversionPair)[tupleIndex]
			: // if it's a legacy inspection, leave it as it is
			  inspectionDetailSelectedUnit;

	return (
		`${normalizedValue !== "null" ? normalizedValue : ""}${
			normalizedValue && normalizedValue !== "null" && normalizedUnit ? ` ${normalizedUnit}` : ""
		}` || defaultValue
	);
};
